import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MockTest } from 'src/app/utils/mock-test';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultasSerasaService {

  constructor(public http: HttpClient) {

  }

  consultasSerasa(): Observable<any> {
    if (environment.name == 'local') {
      return of(MockTest.criarMockHistoricoConsultaSerasa())
    }
    return this.http.get(environment.url + '/lgpd/sintetico/v1/passagens');
}
}
